import { render } from "./Classifications.vue?vue&type=template&id=887ec972&lang=true"
import script from "./Classifications.vue?vue&type=script&lang=js"
export * from "./Classifications.vue?vue&type=script&lang=js"

import "./Classifications.vue?vue&type=style&index=0&id=887ec972&lang=scss"
script.render = render

export default script